import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectTopPlayersState = (state: RootState) => state.topPlayers;

const selectLoading = createDraftSafeSelector(
  selectTopPlayersState,
  state => state.loading
);

const selectLoadingData = createDraftSafeSelector(
  selectTopPlayersState,
  state => state.loadingData
);
const selectTopPlayers = createDraftSafeSelector(
  selectTopPlayersState,
  state => state.topPlayers
);

export {
  selectTopPlayersState,
  selectLoading,
  selectLoadingData,
  selectTopPlayers,
};
